// extracted by mini-css-extract-plugin
export default {"main_container":"DropDownLanguage_main_container__QykRH","arrow_container":"DropDownLanguage_arrow_container__xYeeW","signout_dropdown":"DropDownLanguage_signout_dropdown__a8sTo"};